import { RootState } from "@store/store";
import { useSelector } from "react-redux";

type Module = "COMPANY" | "SERVICE" | "SERVICEENDPOINT" | "USERGROUP" | "USER";
const useEUMSPermission = (module: Module) => {
  const permissions = useSelector(
    (state: RootState) => state.permission.userPermissions
  );
  const serviceCode = "EUMS";
  const eumsPermission = permissions?.[serviceCode];

  const hasAddPermission = !!eumsPermission?.[`ADD${module}`];
  const hasGetAllPermission = !!eumsPermission?.[`GETALL${module}`];
  const hasGetPermission = !!eumsPermission?.[`GET${module}`];
  const hasUpdatePermission = !!eumsPermission?.[`UPDATE${module}`];
  const hasEnableDisablePermission =
    !!eumsPermission?.[`ENABLEDISABLE${module}`];

  return {
    hasAddPermission,
    hasGetAllPermission,
    hasGetPermission,
    hasUpdatePermission,
    hasEnableDisablePermission,
  };
};

export default useEUMSPermission;
